import React, { FC } from "react";

interface InputBlockProps {
    label: string;
    register?: any;
    type: string;
    required?: boolean;
    className?: string;
    disabled?: boolean;
    placeholder?: string;
    absolute?: boolean;
    autoComplete?: string;
    value?: any;
    onChange?: any
    defaultValue?: string;
    name?: string;
}

const InputBlock: FC<InputBlockProps> = ({
    label,
    register = null,
    type,
    required = false,
    className = "",
    disabled = false,
    defaultValue = "",
    placeholder = "",
    absolute = false,
    value = "",
    autoComplete,
    onChange = () => {},
    name = ""
}) => {
    return (
        <div className={`w-full space-y-1 ${className}`}>
            <label htmlFor={label} className={`block text-[14px] font-normal text-[#808080] whitespace-nowrap ${absolute && "sr-only"}`}>
                {label} {required && "*"}
            </label>
            { register ?
            <input
                defaultValue={defaultValue}
                placeholder={placeholder}
                disabled={disabled}
                required={required}
                id={label}
                type={type}
                {...register}
                autoComplete={autoComplete}
                onChange={onChange}
                value={value}
                className="customInput"
            />
            :
            <input
            placeholder={placeholder}
            disabled={disabled}
            required={required}
            id={label}
            type={type}
            autoComplete={autoComplete}
            onChange={onChange}
            value={value}
            name={name}
            className="customInput"
        />}
        </div>
    );
};

export default InputBlock;
